import { Dispatch, SetStateAction, useEffect } from 'react'
import { BreadType } from 'types/bread'
import {
  filterBreadsByCategory,
  filterBreadsByCurrentTab,
  filterBreadsByKeyword,
  filterBreadsByStatus,
  filterBreadsByType,
} from 'lib/filter'
import { CategoryType } from 'types/category'
import { StockType, StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { DayOfWeekType } from 'lib/daysOfWeek'

type UseInitBreadListParams = {
  breads: BreadType[]
  categories: CategoryType[]
  categoryName: string
  keyword: string
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
  isShownPrivate: boolean
  breadTypes?: StockUnionType[]
  stocks?: StockType[]
  schedules?: ScheduleType[]
  isFuture?: boolean
  checkedOrderTypes?: string[]
  dayOfWeek?: DayOfWeekType
  isTemporaryClose?: boolean
  currentTab?: 'released' | 'unreleased'
}

const useInitBreadList = (params: UseInitBreadListParams) => {
  const {
    breads,
    categories,
    categoryName,
    keyword,
    setBreadList,
    isShownPrivate,
    breadTypes,
    stocks,
    schedules,
    isFuture,
    checkedOrderTypes,
    dayOfWeek,
    isTemporaryClose,
    currentTab,
  } = params
  return useEffect(() => {
    if (!breads) return
    // 販売停止中のステータスかどうかでフィルタリング
    let _breads: BreadType[] = filterBreadsByStatus(breads, isShownPrivate)
    // カテゴリが指定されていればフィルタリング
    if (categoryName !== '') {
      _breads = filterBreadsByCategory(categoryName, categories, _breads)
    }
    // 検索キーワードが入力されていればフィルタリング
    if (keyword !== '') {
      _breads = filterBreadsByKeyword(keyword, _breads)
    }
    if (breadTypes) {
      _breads = filterBreadsByType(_breads, breadTypes)
    }
    if (stocks && schedules && dayOfWeek && currentTab && checkedOrderTypes) {
      _breads = filterBreadsByCurrentTab({
        breads: _breads,
        checkedOrderTypes,
        currentTab,
        dayOfWeek,
        stocks,
        schedules,
      })
    }
    setBreadList([..._breads])
  }, [
    breads,
    categories,
    isShownPrivate,
    breadTypes,
    stocks,
    schedules,
    isFuture,
    checkedOrderTypes,
    dayOfWeek,
    isTemporaryClose,
    currentTab,
  ])
}

export default useInitBreadList
